export default __webpack_public_path__ + "static/media/img-the-new-playbook-2021.fc41ef66.png";